import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['container', 'form', 'displayName', 'contextSdr', 'contextSupport',
                     'purposeStartConversation', 'purposeBroadcast', 'purposeReengage', 'purposeRelocation',
                     'purposeCaptacao', 'folder']

  open(event) {
    event.preventDefault()
    const button = event.currentTarget

    const templateId = button.dataset.templateId
    const displayName = button.dataset.templateDisplayName || ''
    const contextType = button.dataset.templateContextType || ''
    const purposes = (button.dataset.templatePurposes || '').split(',').filter(Boolean)

    // Update form action
    const formAction = this.formTarget.action.replace('__TEMPLATE_ID__', templateId)
    this.formTarget.action = formAction

    // Fill fields
    this.displayNameTarget.value = displayName

    // Set context radio
    if (contextType.includes('Support')) {
      this.contextSupportTarget.checked = true
    } else {
      this.contextSdrTarget.checked = true
    }

    // Set purpose checkboxes
    this.purposeStartConversationTarget.checked = purposes.includes('start_conversation')
    this.purposeBroadcastTarget.checked = purposes.includes('broadcast')
    this.purposeReengageTarget.checked = purposes.includes('reengage')
    this.purposeRelocationTarget.checked = purposes.includes('relocation')
    this.purposeCaptacaoTarget.checked = purposes.includes('captacao')

    if (this.hasFolderTarget) {
      this.folderTarget.value = button.dataset.templateFolderId || ''
      this.formTarget.querySelector('[name="context_type"]:checked')
        .dispatchEvent(new Event('change', { bubbles: true }))
    }

    // Show modal
    this.containerTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
  }

  close(event) {
    if (event) event.preventDefault()
    this.containerTarget.classList.add('hidden')
    document.body.style.overflow = 'auto'

    // Reset form action for next use
    this.formTarget.action = this.formTarget.dataset.originalAction
  }

  closeOnBackdrop(event) {
    if (event.target === this.containerTarget) {
      this.close(event)
    }
  }

  connect() {
    this.escHandler = (event) => {
      if (event.key === 'Escape' && !this.containerTarget.classList.contains('hidden')) {
        this.close()
      }
    }
    document.addEventListener('keydown', this.escHandler)

    if (this.hasContainerTarget) {
      this.containerTarget.addEventListener('click', (event) => this.closeOnBackdrop(event))
    }

    // Store original form action (with placeholder)
    if (this.hasFormTarget) {
      this.formTarget.dataset.originalAction = this.formTarget.action
    }
  }

  disconnect() {
    document.removeEventListener('keydown', this.escHandler)
    document.body.style.overflow = 'auto'
  }
}
